import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Modal, Popup, Segment, TextArea,Image,Message} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import {deleteImageFromReport, uploadDisclaimerDetails} from "../../data/report_api";
import Loader from "../universal/loader";
import AddNewDisclaimerNotes from "./add_new_disclaimer_notes";
import { DropzoneComponent } from "react-dropzone-component";
import * as fileIcon from "../../assets/fileIcon.png";

const uuidv1 = require('uuid/v1');

class DisclaimerNotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDisclaimerSection: false,
            showEdit: undefined,
            disclaimerDesc: undefined,
            disclaimerTitle: undefined,
            disclaimerType: undefined,
            imageEdit: undefined,
            imageFile: undefined,
            showAddSection:true,
            addDisclaimerImage:undefined,
            errorMsg:undefined,
            imgErrorMsg:undefined,
            failedUploads:[]
        }
    }

    componentWillMount() {
        this.setState({showDisclaimerSection: this.props.showDisclaimer});
    }

    removingFile = (file,disclaimerObj,index) => {
        if (file.id) {
            deleteImageFromReport(file.id).then((res) => {
            });
        }
        else {
            this.props.removeMediaFromDisclaimer(index,disclaimerObj,file)
        }
        this.props.removeMediaFromDisclaimer(index,disclaimerObj,file)
    };

    handleShowAddSection = () => {
        this.setState({showAddSection:false});
        setTimeout(()=>{
            this.setState({showAddSection:true})
        },10);
    };

    updateDisclaimerDetail = (disclaimer, key) => {
        if (!disclaimer['action']) {
            disclaimer['action'] = 'update';
        }
        if (key === 'title') {
            disclaimer['title'] = this.state.disclaimerTitle;
        }
        if (key === 'desc') {
            disclaimer['description'] = this.state.disclaimerDesc;
        }
        if (key === 'type') {
            disclaimer['section_type'] = this.state.disclaimerType;
        }
        this.props.updateDisclaimerInReport(disclaimer);
    };

    deleteDisclaimer = (disclaimer) => {
        this.props.deleteDisclaimerInReport(disclaimer);
    };

    uploadDisclaimer = () => {
        this.setState({isSaving: true,errorMsg:undefined,imgErrorMsg:undefined});
        let newUploadableDisclaimer = JSON.parse(JSON.stringify(this.props.updateDisclaimer));
        let uploadableDisclaimer = newUploadableDisclaimer.disclaimers;
        for (let i = 0; i < uploadableDisclaimer.length; i++) {
            if (uploadableDisclaimer[i] && uploadableDisclaimer[i]['images']) {
                const image = this.props.updateDisclaimer.disclaimers[i]['images'];
                for (let j = 0; j < image.length; j++) {
                    uploadableDisclaimer[i]['images'][j] = {id: uploadableDisclaimer[i]['images'][j]['id']}
                }
            }
        }
        newUploadableDisclaimer.disclaimers = uploadableDisclaimer.filter(receipt => receipt !== null);;
        newUploadableDisclaimer.images = undefined
        if (newUploadableDisclaimer.disclaimers.length > 0 || this.props.updateDisclaimer.images.length > 0) {

            uploadDisclaimerDetails(newUploadableDisclaimer).then((response) => {
                if (response.success) {
                    let images = this.props.updateDisclaimer.images;
                    if (images.length > 0) {
                        for (let i = 0; i < images.length; i++) {
                            const formData = new FormData();
                            formData.append("id", images[i].id);
                            formData.append("file", images[i].file);
                            if (i === images.length - 1) {
                                this.props.uploadImages(formData, this.completeCallBack);
                            } else {
                                this.props.uploadImages(formData, this.successFn);
                            }
                        }
                    } else {
                        this.completeCallBack(response,undefined);
                    }
                } else {
                    this.setState({errorMsg:response.statusMessage || "There was an error while saving, please try again",isSaving:false})
                }
            }).catch((e) => {
                {this.setState({errorMsg:"There was an error while saving, please try again",isSaving:false})}
            });
        } else {
            this.exitWindow()
        }
    };

    successFn = (response, image) => {
        if (!response.success) {
            this.setState({failedUploads:[...this.state.failedUploads, image]})
        }
    };

    exitWindow = () =>{
        this.props.resetDataQueuedInAPI('disclaimers');
        this.setState({isSaving:false});
        this.props.handleClose();
    }

    completeCallBack = (response,image) => {
        if (!response.success && image) {
            let error = undefined
            let err = response.statusMessage
            if (err.response) {
                error = err.response.data.error || "An error occurred on the server.";
            } else if (err.request) {
                error = "Network error: Please check your internet connection.";
            } else {
                error = err.message || "An unknown error occurred.";
            }
            this.setState({failedUploads:[...this.state.failedUploads, image], isSaving:false, imgErrorMsg:error})
        } else {
            this.props.resetDataQueuedInAPI('disclaimers');
            this.setState({isSaving:false});
            this.props.handleClose();
        }
    };

    retryImageUpload = () =>{
        let images = [...this.state.failedUploads]
        this.setState({isSaving:true,imgErrorMsg:undefined,failedUploads:[]})
        if (images.length > 0) {
            for (let i = 0; i < images.length; i++) {
                if(i === images.length-1){
                    this.props.uploadImages(images[i], this.completeCallBack);
                }
                else {
                    this.props.uploadImages(images[i], this.successFn);
                }
            }
        }
        else {
            this.completeCallBack({success:true});
        }

    }

    completeFn = () => {
        this.props.resetDataQueuedInAPI('disclaimers');
        this.setState({isSaving: false});
        this.props.handleClose();
    };

    render() {
        const moduleTypeOptions = [
            {key: 0, text: "Disclaimer", value: "disclaimer"},
            {key: 1, text: "Customer Service Note", value: "customer_service"},
            {key: 2, text: "General Notes", value: "notes"},
        ];

        const moduleTypeMap = {"disclaimer":"Disclaimer","customer_service":"Customer Service Note","notes":"General Notes"};
        const arr = [1];
        const disclaimers = this.props.reportDetails.disclaimers;
        const ci_disclaimers = this.props.reportDetails.ci_disclaimers;
        return (<Segment>
            {this.state.isSaving && <Loader save={true}/>}
            <Modal size="small" open={this.state.showDisclaimerSection} onClose={(e) => {
                this.uploadDisclaimer();
            }}>
                <Modal.Content style={{minHeight: '500px', overflowY: 'scroll'}}>
                    <Header floated="right"><Icon className="icon-button" name="save" onClick={(e) => {
                        this.uploadDisclaimer();
                    }}/></Header>
                    <Modal.Description>
                        <Header as='h2' textAlign='center'>
                            Additional Disclaimer/Notes
                        </Header>
                         {this.state.errorMsg && <Message>There was an error while saving disclaimer details, please try again.   {this.state.errorMsg} <hr/>  <Button compact onClick={this.uploadDisclaimer}>Retry Save</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                            {this.state.failedUploads.length > 0 && <Message> {this.state.failedUploads.length} Image(s) failed to upload, try again? {this.state.imgErrorMsg}<hr/> <Button compact onClick={this.retryImageUpload}>Retry Upload</Button> <Button compact onClick={this.exitWindow}>Exit Window</Button> </Message>}
                        {disclaimers ? disclaimers.map((disclaimer, index) => {
                            function preloadImages(dropzone) {
                                (disclaimer.images || []).forEach(function (i) {
                                    const name = i.id;
                                    let file = {url: i['image_path'], name: name, size: 1000000, id: name};
                                    let imageUrl = i['image_path'];
                                    if (i.file) {
                                        file = i.file;
                                        imageUrl = i.file.dataURL;
                                    }
                                    if(i.image){
                                        file = i.image.file;
                                        imageUrl = i.image.file.dataURL;
                                    }

                                    file['serverId'] = name;
                                    file['accepted'] = true;
                                    file['status'] = 'success';
                                    file['upload'] = {
                                        progress: 100,
                                        total: 100000,
                                        bytesSent: 100000
                                    };
                                    dropzone.files.push(file);

                                    dropzone.emit("addedfile", file);
                                    if (i.file) {
                                        if (!i.file.type.match(/image/i))
                                        {
                                            dropzone.emit("thumbnail", file, fileIcon);
                                        } else {
                                            dropzone.emit("thumbnail", file, imageUrl);
                                        }
                                    } else
                                    {
                                       file.type != "application/pdf"? dropzone.emit("thumbnail", file, imageUrl): dropzone.emit("thumbnail", file, fileIcon);
                                    }
                                    dropzone.emit("complete", file);
                                });
                            }

                            let dropZone = null;
                            const componentConfig = {postUrl: 'no-url'};

                            let djsConfig = {
                                autoProcessQueue: false,
                                addRemoveLinks: true,
                                acceptedFiles: "image/*, application/pdf",
                            };
                            const eventHandlers = {
                                init: (dropzone) => {
                                    dropZone = dropzone;
                                    dropZone.autoDiscover = false;
                                    preloadImages(dropzone);
                                },
                                addedfile: (file) => {
                                    let imageObj = {
                                        id: file.upload.uuid,
                                        file: file,
                                    };
                                    this.props.addNewDisclaimerMedia(index, imageObj);
                                },
                                removedfile: (file) => {
                                    this.removingFile(file,disclaimer,index);
                                }
                            };
                            return (<Segment key={disclaimer['client_id']}>
                                <Popup
                                    trigger={<Icon size="large" name="trash"
                                                   className="icon-button info-grey pull-right"/>}
                                    content={<Button negative content="Confirm Delete?"
                                                     onClick={() => {
                                                         this.deleteDisclaimer(disclaimer)
                                                     }}/>}
                                    on="click"
                                    position="left center"
                                    hideOnScroll
                                />
                                <div ref={disclaimer['client_id']}>
                                    <Grid style={{marginTop: '0'}}>
                                        <Grid.Row>

                                            <Grid.Column width={2}>
                                                <Header><span onClick={() => {
                                                    this.setState({showTitleEdit: disclaimer['client_id']})
                                                }}>Title : </span></Header>
                                            </Grid.Column>
                                            <Grid.Column width={10}>
                                                {this.state.showTitleEdit ===  disclaimer['client_id'] ?
                                                    <div>
                                                        <Form onSubmit={() => {
                                                            this.updateDisclaimerDetail(disclaimer, "title")
                                                        }}>
                                                            <Form.Input
                                                                type="text"
                                                                defaultValue={disclaimer['title']}
                                                                placeholder="Disclaimer title"
                                                                required
                                                                autoFocus
                                                                onFocus={(e) => {
                                                                    this.setState({disclaimerTitle: e.target.value})
                                                                }}
                                                                onChange={(e) => {
                                                                    this.setState({disclaimerTitle: e.target.value})
                                                                }}
                                                                onBlur={() => {
                                                                    this.setState({showTitleEdit: undefined});
                                                                    this.updateDisclaimerDetail(disclaimer, "title");
                                                                }}
                                                            />
                                                        </Form>
                                                    </div> : <div>
                                                        <span onClick={() => {
                                                            this.setState({showTitleEdit: disclaimer['client_id']})
                                                        }}>{disclaimer['title']}</span>
                                                    </div>
                                                }
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={2}>
                                                <Header><span onClick={() => {
                                                    this.setState({showTypeEdit: disclaimer['client_id']})
                                                }}>Type :</span></Header>
                                            </Grid.Column>
                                            <Grid.Column width={10}>
                                                {this.state.showTypeEdit === disclaimer['client_id'] ?
                                                    <Form onSubmit={() => {
                                                        this.updateDisclaimerDetail(disclaimer, "type")
                                                    }}>
                                                        <Form.Dropdown
                                                            label={this.state.showTypeEdit === disclaimer['client_id']?"":"Module Type"}
                                                            required={this.state.showTypeEdit !== disclaimer['client_id']}
                                                            selection
                                                            wrapSelection={false}
                                                            selectOnBlur={false}
                                                            defaultValue={disclaimer['section_type']}
                                                            options={moduleTypeOptions}
                                                            placeholder='Module Type'
                                                            onChange={(e, option) => {
                                                                this.setState({disclaimerType: option.value},()=>{
                                                                    this.updateDisclaimerDetail(disclaimer, "type");
                                                                    this.setState({showTypeEdit:undefined})});
                                                            }}
                                                            onBlur={()=>{
                                                                this.setState({showTypeEdit:undefined});
                                                            }}
                                                        />
                                                    </Form> :<span onClick={() => {
                                                        this.setState({showTypeEdit: disclaimer['client_id']})
                                                    }}>{disclaimer['section_type']?moduleTypeMap[disclaimer['section_type']]:"NA"}</span>
                                                }
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <Header><span onClick={(e) => {
                                                    this.setState({showDescEdit: disclaimer['client_id']});
                                                }}>Description :</span></Header>
                                                {this.state.showDescEdit === disclaimer['client_id'] ?
                                                    <Form onSubmit={() => {
                                                        this.updateDisclaimerDetail(disclaimer, "desc")
                                                    }}>
                                                    <TextArea style={{verticalAlign: 'middle'}}
                                                              defaultValue={disclaimer['description']}
                                                              placeholder="Description"
                                                              autoFocus fluid rows={3}
                                                              onFocus={(e) => {
                                                                  this.setState({disclaimerDesc: e.target.value})
                                                              }}
                                                              onChange={(e) => {
                                                                  this.setState({disclaimerDesc: e.target.value})
                                                              }}
                                                              onBlur={() => {
                                                                  this.setState({showDescEdit: undefined});
                                                                  this.updateDisclaimerDetail(disclaimer,"desc");
                                                              }}
                                                              required
                                                    />
                                                    </Form> : <span onClick={(e) => {
                                                        this.setState({showDescEdit: disclaimer['client_id']});
                                                    }}>{disclaimer['description']}</span>
                                                }
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column>
                                                <div>
                                                    {disclaimer.images && arr.map((n,i)=>{
                                                        function preloadImages(dropzone) {
                                                            (disclaimer.images || []).forEach(function (i) {
                                                                const name = i.id;
                                                                let file = {url: i['image_path'], name: name, size: 1000000, id: name};
                                                                let imageUrl = i['image_path'];
                                                                if (i.image) {
                                                                    file = i.image.file;
                                                                    imageUrl = i.image.file.dataURL;
                                                                }

                                                                file['serverId'] = name;
                                                                file['accepted'] = true;
                                                                file['status'] = 'success';
                                                                file['upload'] = {
                                                                    progress: 100,
                                                                    total: 100000,
                                                                    bytesSent: 100000
                                                                };
                                                                dropzone.files.push(file);

                                                                dropzone.emit("addedfile", file);
                                                                dropzone.emit("thumbnail", file, imageUrl);
                                                                dropzone.emit("complete", file);
                                                            });
                                                        }
                                                        return <DropzoneComponent key={i} config={componentConfig}
                                                                                  eventHandlers={eventHandlers}
                                                                                  djsConfig={djsConfig}/>
                                                    })}
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>

                                    </Grid>
                                </div>
                            </Segment>);
                        }) : null}
                        {this.state.showAddSection ? <AddNewDisclaimerNotes flipShowAddSection={this.handleShowAddSection}/>:<div style={{minHeight:'2em'}}></div>}
                        {ci_disclaimers ? ci_disclaimers.length > 0 && <div style={{float:"left"}}><Header as='h2' textAlign='center'>Check In Addendums</Header>
                            {ci_disclaimers.map((disclaimer) => {
                                return (
                                  <Segment>
                                    <Grid>
                                      <Grid.Row>
                                        <Grid.Column width={2}>
                                          <Header>Title :</Header>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                          <span>{disclaimer.title}</span>
                                        </Grid.Column>
                                      </Grid.Row>
                                      <Grid.Row>
                                        <Grid.Column width={2}>
                                          <Header>Type :</Header>
                                        </Grid.Column>
                                        <Grid.Column width={10}>
                                          <span>{disclaimer.section_type}</span>
                                        </Grid.Column>
                                      </Grid.Row>
                                      <Grid.Row>
                                        <Grid.Column>
                                          <Header>Description :</Header>
                                        </Grid.Column>
                                      </Grid.Row>
                                      <Grid.Row>
                                        <Grid.Column>
                                          <span>{disclaimer.description}</span>
                                        </Grid.Column>
                                      </Grid.Row>
                                      <Grid.Row>
                                        <Grid.Column>
                                          <Header>Images :</Header>
                                        </Grid.Column>
                                      </Grid.Row>
                                      <Grid.Row>
                                        <Grid.Column>
                                          <Image.Group>
                                            {disclaimer.images.map((image) => {
                                              return (
                                                <Image
                                                  width="250px"
                                                  height="250px"
                                                  src={
                                                    image["image_path"]
                                                      ? image["image_path"]
                                                      : null
                                                  }
                                                  rounded
                                                  centered
                                                />
                                              );
                                            })}
                                          </Image.Group>
                                        </Grid.Column>
                                      </Grid.Row>
                                    </Grid>
                                  </Segment>
                                );
                            })}
                        </div> : null}
                        
                    </Modal.Description>
                </Modal.Content>
            </Modal>
        </Segment>);
    }
}

export default ReportContainer(DisclaimerNotes);


// WEBPACK FOOTER //
// ./src/views/report/disclaimer_notes.js